import React from 'react';

interface IFontStyleProps {
	fontOptions: object,
	fontStyle: {
		bold: boolean,
		italic: boolean,
	},
	toggleFontStyle: (style: string) => void,
}

export const FontStyle: React.FunctionComponent<IFontStyleProps> = ({ fontOptions, fontStyle, toggleFontStyle }) => {

	const boldCName = fontStyle.bold ? 'boldBtn ciq-active' : 'boldBtn';
	const italicCName = fontStyle.italic ? 'italicBtn ciq-active' : 'italicBtn';

	const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.currentTarget.dataset.style) { toggleFontStyle(e.currentTarget.dataset.style) }
	}

	if (!fontOptions) { return <span />; }
	return (
		<span>
			<div className={boldCName} data-style={'bold'} onClick={onClick}>B</div>
			<div className={italicCName} data-style={'italic'} onClick={onClick}>I</div>
		</span>
	);
};